// extracted by mini-css-extract-plugin
export default {"rows":"SocialRows_rows__24anW","row":"SocialRows_row__OoKmU","handle":"SocialRows_handle__EvwkC","url":"SocialRows_url__pOXJO","alt":"SocialRows_alt__fntd3"};